import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { AccountingRange } from 'src/features/accountingRanges/utils/types';
import { AccountingRangeFormSchemaValues } from 'src/features/accountingRanges/utils/formSchema';

const RESOURCE = '/financial-documents/accounting-range/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: AccountingRangeFormSchemaValues): Promise<AccountingRange> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateAccountingRange };
